import { Button } from '@components/ui'
import { Row } from '@tanstack/react-table'
import {
  commonActionColumn,
  getIconComponent
} from '@utils/assessmentReportUtils'

import {
  Database_Procs_GetWDYKTestAssessmentByBatch_Item,
  Entities_Modules_Assign_Player
} from '@suntex.fim/api-client'

import { createColumn } from './AssessmentReportSummaryTable'
import {
  generateCommonColumns,
  generateScrollableAssessmentCommonColumns,
  renderWrappedAssessmentHeader
} from './CommonColumns'

/**
 * handles hidable columns list
 */
const userDetails = {
  userId: 'User ID',
  displayName: 'Display Name',
  stickers: 'Stickers'
}

const questions = Array.from({ length: 10 }, (_, i) => ({
  [`_${i + 1}`]: `Q${i + 1}`
})).reduce((acc, curr) => ({ ...acc, ...curr }), {})

export const hidableSelectLabel: Record<string, string> = {
  ...userDetails,
  ...questions
}

/**
 * returns JSX for very important facts report table
 */
function columns({
  sendMessage,
  showQuestion
}: {
  sendMessage: (
    t: Row<Database_Procs_GetWDYKTestAssessmentByBatch_Item>[]
  ) => void
  showQuestion?: (columnId: string) => Promise<void>
}) {
  const choices = Array.from({ length: 10 }, (_, i) => `_${i + 1}`)

  const createCheckboxColumn = (index: number | string) => {
    const label = `Q${(index as string).replace('_', '')}`
    return createColumn<Database_Procs_GetWDYKTestAssessmentByBatch_Item>(
      label,
      `${index}` as keyof Database_Procs_GetWDYKTestAssessmentByBatch_Item, // Type assertion here
      `${index}` as keyof Database_Procs_GetWDYKTestAssessmentByBatch_Item, // Type assertion here
      90,
      (info) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const value = info.getValue()
        const IconComponent = getIconComponent(value)
        return (
          <Button
            intent="icon"
            aria-label={`Show ${label} question`}
            onClick={() => void showQuestion?.(`${index}`)}
          >
            {IconComponent}
          </Button>
        )
      },
      { header: () => renderWrappedAssessmentHeader(label) }
    )
  }

  const totalScoreColumn =
    createColumn<Database_Procs_GetWDYKTestAssessmentByBatch_Item>(
      'Total Score',
      'totalScore',
      () => {},
      120,
      (info) => {
        const totalScore = choices.reduce(
          (sum, choice) => sum + (info.row.original[`${choice}`] > 0 ? 1 : 0),
          0
        )
        return (
          <div>
            <span>
              <b>{`${totalScore.toLocaleString()}/10`}</b>
            </span>
          </div>
        )
      },
      {
        enableSorting: false,
        header: () => renderWrappedAssessmentHeader('Total Score')
      }
    )

  return [
    commonActionColumn<Database_Procs_GetWDYKTestAssessmentByBatch_Item>(
      hidableSelectLabel,
      sendMessage
    ),
    ...generateScrollableAssessmentCommonColumns<Database_Procs_GetWDYKTestAssessmentByBatch_Item>(),
    ...choices.map(createCheckboxColumn),
    totalScoreColumn
  ]
}
function testColumns() {
  const columns: {
    label: string
    key: keyof Entities_Modules_Assign_Player
  }[] = [
    { label: 'User Id', key: 'userId' },
    { label: 'Display name', key: 'name' },
    { label: 'Stickers', key: 'stickers' }
  ]
  return [
    generateCommonColumns<Database_Procs_GetWDYKTestAssessmentByBatch_Item>()[0],
    ...columns.map(({ label, key }) =>
      createColumn<Entities_Modules_Assign_Player>(
        label,
        key,
        key,
        50,
        (info) => info.getValue()
      )
    )
  ]
}

export { columns, testColumns }
